import React, { useState, useEffect } from 'react';
import { FaArrowDown, FaInstagram, FaWhatsapp } from 'react-icons/fa'; // Import colorful icons from react-icons/fa
import './SocialMediaTab.css'; // Import CSS file for styling

const SocialMediaTab = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrollTop < 100); // Change 100 to the scroll threshold at which you want the button to appear
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`social-media-tab ${isVisible ? 'show' : 'hide'}`}>
      <div className={`arrow-button ${isExpanded ? 'expanded' : ''}`} onClick={toggleExpand}>
        {/* Use right arrow icon from Font Awesome */}
        <FaArrowDown />
      </div>
      <div className={`social-media-icons ${isExpanded ? 'show' : ''}`}>
        {/* Use colorful icons from react-icons */}
        <a href="https://www.instagram.com/shanzaeziaphotography/" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="https://wa.me/+923095921582" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp />
        </a>
        {/* Add more social media icons as needed */}
      </div>
    </div>
  );
};

export default SocialMediaTab;